
/**
 * Chuẩn hóa chuỗi tiếng Việt: loại bỏ dấu và chuyển về chữ thường.
 * Giữ nguyên các ký tự đặc biệt và khoảng trắng.
 */
export function normalizeText(str: string): string {
    if (!str) return '';
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Loại bỏ dấu
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase();
}

/**
 * Kiểm tra xem text có chứa search hay không (không phân biệt hoa thường, không phân biệt dấu).
 */
export function accentInsensitiveIncludes(text: string, search: string): boolean {
    if (!search) return true;
    if (!text) return false;
    return normalizeText(text).includes(normalizeText(search));
}
